module.exports = __webpack_public_path__ + "media/tacklebox/assets/images/views/advertisements/rakuten-b2a33403b614c404b3b7fcdc9a4ce0c5.png";